import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

/**
 * Поиск детали при кроссировании.
 */
export default class extends Controller {
  static get targets() {
    return ['select', 'users'];
  }

  initialize() {
    this.timeout = null;
    this.companyIdField = this.element.querySelector('[name="company_id"]');
  }

  connect() {
    const that = this;
    this.selectTarget.addEventListener('change', () => this.searchUsers());
  }

  disconnect() {
    this.selectTarget.removeEventListener('change', () => this.ssearchUsers());
  }

  renderNotFound() {
    this.usersTarget.innerHTML = `<div class="dropdown-item">У организации нет активных пользователей.</div>`;
    this.usersTarget.style.display = null;
  }

  renderEmpty() {
    this.usersTarget.innerHTML = `<div class="dropdown-item">Укажите клиента!</div>`;
    this.usersTarget.style.display = null;
  }

  renderUser(user) {
    return `
      <li>
        <label>
          <input type="checkbox" data-target="form--checkboxes.checkbox" checked="checked" value="${user.id}"
          name="commercial_offer[user_ids][]" id="user_ids_${user.id}">
          ${user.name}
        </label>
      </li>
    `;
  }

  renderUsers(users) {
    const result = ['<p class="help is-size-7">Сотрудники организации, которым будет отправлено коммерческое предложение:</p><ul data-controller="form--checkboxes">'];
    if (users.length > 1) {
      result.push(`
        <li class="is-italic">
          <input type="checkbox" checked="checked" data-action="form--checkboxes#toggle"> Выбрать все
        </li>
      `);
    }
    for (const user of users) {
      result.push(this.renderUser(user));
    }
    result.push('</ul>');
    this.usersTarget.innerHTML = result.join('');
    this.usersTarget.style.display = null;
  }

  searchUsers() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      const company_id = this.selectTarget.value;
      const that = this;
      if (company_id == '') {
        that.renderEmpty();
      } else {
        Rails.ajax({
          type: 'GET',
          url: `/office/companies/users_search?id=${company_id}`,
          success: (data) => {
            if (data.length > 0) {
              that.renderUsers(data);
            } else {
              that.renderNotFound();
            }
          },
          error: () => {
            alert('Ошибка при попытке найти пользователей выбранной организации');
          },
        });
      }
    }, 500);
  }

  selectPart(event) {
    this.brandField.value = event.target.dataset.brandId;

    this.articleField.value = event.target.dataset.article;

    this.partIdField.value = event.target.dataset.partId;

    this.partsTarget.style.display = 'none';
  }
}
